import { Collection, Q } from '@nozbe/watermelondb';

import { EventContactModel } from '../../../../types/EventContact';

export const prepareUpdateEventContactInvitations = async ({
    eventId,
    contactId,
    payload,
    collection,
}: {
    eventId: string;
    contactId: string;
    payload: Partial<{ sendSMS: boolean; sendEmail: boolean }>;
    collection: Collection<EventContactModel>;
}) => {
    const eventContacts = await collection
        .query(
            Q.and(
                Q.where('event_id', eventId),
                Q.where('contact_id', contactId),
            ),
        )
        .fetch();

    if (!eventContacts.length || !eventContacts[0]) {
        return null;
    }

    return eventContacts[0].prepareUpdate((eventContact) => {
        eventContact.sentSms = payload.sendSMS || eventContact.sentSms;
        eventContact.sentEmail = payload.sendEmail || eventContact.sentEmail;
    });
};
